<template>
  <div>
    <v-card flat>
      <v-card-title>
        Device Licenses
        <v-spacer/>
        <v-btn
          x-small
          outlined
          class="mr-1"
          color="secondary"
          @click="reloadLicenses"
          tooltip="Reload Licenses"
        >
          Reload
        </v-btn>
        <entitlement-debug :device="device" v-if="device.canControl() && isDeviceAdmin" />
      </v-card-title>
      
      <v-card-text>
        <v-alert dense outlined type="error" v-if="error" >
          {{ errorText }}
        </v-alert>
        
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="device.licenses"
              :items-per-page="itemsPerPage"
              hide-default-footer
            >
              <template v-slot:item.profile_guid="{ item }">
                <v-row class="align-center">
                  <span v-if="item.license_name" class="subtitle-1" :class="(item.expired) ? 'red--text' : ''">{{ item.license_name }}</span>
                  <span v-else class="subtitle-1" :class="(item.expired || $entitlementProfiles.getEntitlementProfile(item.profile_guid).error) ? 'red--text' : ''">
                    {{
                      !$entitlementProfiles.getEntitlementProfile(item.profile_guid).error
                        ? $entitlementProfiles.getEntitlementProfile(item.profile_guid).displayName()
                        : 'Entitlement Not Found'
                    }}
                  </span>
                  <v-chip
                    class="ml-3"
                    color="error"
                    small
                    pill
                    v-if="item.expired"
                  >
                    Expired
                  </v-chip>
                  <v-chip
                    class="ml-3"
                    color="accent"
                    small
                    pill
                    v-if="item.pending_deallocation"
                  >
                    Pending Deallocation
                  </v-chip>
                </v-row>
              </template>
              <template v-slot:item.license_type="{ item }">
                {{ licenseTypeLabel(item.license_type) }}
              </template>
              <template v-slot:item.created="{ item }">
                <span>{{ item.created | moment("YYYY/MM/DD") }}</span>
              </template>
              <template v-slot:item.expires="{ item }">
                <span v-if="item.expires" :class="(item.expired) ? 'red--text' : ''">{{ item.expires | moment("YYYY/MM/DD") }}</span>
                <span v-else>Never</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'DeviceLicenses',
    
    props: ['device_guid', 'device'],
        
    data() {
      return {
        error: false,
        errorText: '',
        
        headers: [
          { text: 'License Name', align: '', value: 'profile_guid', sortable: false },
          { text: 'License Type', align: '', value: 'license_type', sortable: false },
          { text: 'Issue Date', align: 'center', value: 'created', sortable: false },
          { text: 'Expiration Date', align: 'center', value: 'expires', sortable: false },
        ],
        
        itemsPerPage: 50,
      }
    },
    computed: {
      ...mapGetters('user', ['user', 'guid', 'organization', 'isDeviceAdmin']),
    },
    methods: {
      licenseTypeLabel(license_type) {
        if (license_type == 'base') {
          return 'Device Base License'
        } else if (license_type == 'per-device') {
          return 'Device License'
        } else if (license_type == 'all-devices') {
          return 'Organization License'
        }
        return 'Unknown'
      },
      reloadLicenses() {
        this.device.fetchLicenses()
      }
    }
  }
</script>
